// extracted by mini-css-extract-plugin
export default {"content":"QgdWM","button":"qqGyO","textWrapper":"sELTa","text":"DoqGa","price":"zscDd","arrow":"VDBY2","popoverInfo":"sJwA_","popover":"BETug"};